import React, { useEffect, useState } from "react";
import { Button, Checkbox, Select, Table, Tooltip } from "antd";
import { useNavigate } from "react-router-dom";
import { EyeFilled } from "@ant-design/icons";
import "../../../css/common.css";
import { post } from "../../../../services/services.js";
import { ApiURL } from "../../../../services/apiConstants.js";

const ListFuelChangeoverCom = () => {
  const navigate = useNavigate();
  const [page_loader, set_page_loader] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [ship_id, set_ship_id] = useState("");
  const [ship_table_list, set_ship_table_list] = useState([]);

  useEffect(() => {
    SHIP_LIST_API();
  }, []);

  const SHIP_LIST_API = () => {
    const FORM_DATA = new FormData();
    try {
      post(ApiURL.list_ships_view_com, FORM_DATA).then((res) => {
        if (res?.status == true) {
          set_ship_table_list(res?.ships);
          set_ship_id(res?.ships[0]?.id);
          LIST_FUEL_CHARGEOVER_API(res?.ships[0]?.id);
        }
      });
    } catch (error) {
      console.error("Error fetching ship list:", error);
    } finally {
    }
  };

  const LIST_FUEL_CHARGEOVER_API = (ship_id) => {
    set_page_loader(true);
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("ship_id", ship_id);
      post(ApiURL.list_bunker_fuel_chargerover_fcr_com, FORM_DATA).then((res) => {
        if (res?.status == true) {
          const reversedData = res.response_data;
          setFilteredData(reversedData);
        }
        set_page_loader(false);
      });
    } catch (error) {
      console.error("Error fetching Staff list:", error);
      set_page_loader(false);
    }
  };

  const columns = [
    {
      title: "Id",
      dataIndex: "record_id",
      align: "center",
      key: "record_id",
      sorter: (a, b) => a.id - b.id,
      render: (text, record) => (
        <span style={record?.soft_delete ? { textDecoration: "line-through" } : {}}>
          {record?.id}
        </span>
      ),
    },
    {
      title: "Date and time of completion of change-over to low sulphur fuel oil",
      dataIndex: "date_and_time_completion",
      align: "center",
      key: "date_and_time_completion",
      render: (text, record) => (
        <span style={record?.soft_delete ? { textDecoration: "line-through" } : {}}>
          {record?.date_and_time_completion}
        </span>
      ),
    },
    {
      title: "Ship Position",
      dataIndex: "ship_position",
      align: "center",
      key: "ship_position",
      render: (text, record) => (
        <span style={record?.soft_delete ? { textDecoration: "line-through" } : {}}>
          {record?.ship_position}
        </span>
      ),
    },
    {
      title: "Low sulphur fuel oil quantities at completion of change over (Tank ID/m3)",
      dataIndex: "low_sulphur_quality_completion",
      align: "center",
      key: "low_sulphur_quality_completion",
      render: (text, record) => (
        <span style={record?.soft_delete ? { textDecoration: "line-through" } : {}}>
          {record?.low_sulphur_quality_completion}
        </span>
      ),
    },
    {
      title: "Date and time of entry into ECA-Sox",
      dataIndex: "date_and_time_entry_eca",
      align: "center",
      key: "date_and_time_entry_eca",
      render: (text, record) => (
        <span style={record?.soft_delete ? { textDecoration: "line-through" } : {}}>
          {record?.date_and_time_entry_eca}
        </span>
      ),
    },
    {
      title: "Date and time of exit from ECA-Sox",
      dataIndex: "date_and_time_exit_eca",
      align: "center",
      key: "date_and_time_exit_eca",
      render: (text, record) => (
        <span style={record?.soft_delete ? { textDecoration: "line-through" } : {}}>
          {record?.date_and_time_entry_eca}
        </span>
      ),
    },
    {
      title: (
        <Tooltip title={"No selections"}>
          <div style={{ textAlign: "center" }}>
            <span>Confirmed by Chief Engineer</span>
            <Checkbox
              style={{ marginLeft: 8 }}
              checked={
                filteredData.length > 0 &&
                filteredData.every((item) => item.confirm_by_chiefEngneer)
              }
              indeterminate={
                filteredData.some((item) => item.confirm_by_chiefEngneer) &&
                !filteredData.every((item) => item.confirm_by_chiefEngneer)
              }
              disabled
            />
          </div>
        </Tooltip>
      ),
      dataIndex: "updated_at",
      align: "center",
      key: "chief_review",
      render: (text, record, index) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Checkbox checked={record.confirm_by_chiefEngneer} disabled />
          <span
            style={{
              marginLeft: 8,
              textDecoration: record?.soft_delete ? "line-through" : "none",
            }}
          >
            Confirmed by Chief Engineer
          </span>
        </div>
      ),
    },

    {
      title: "Action",
      align: "center",
      key: "Action",
      render: (text, record) => (
        <Tooltip title="View">
          <Button
            type="primary"
            size="small"
            onClick={() => navigate(`/view-fuel-changeover-com/${btoa(record?.id)}`)}
            icon={<EyeFilled />}
          />
        </Tooltip>
      ),
    },
  ];

  return (
    <>
      <div className="row">
        <div className="col-3">
          <label className="block-label">Select Ship</label>
          <Select
            placeholder="---- Select Ship ----"
            style={{ width: "100%" }}
            value={ship_id}
            onChange={(value) => {
              set_ship_id(value);
              LIST_FUEL_CHARGEOVER_API(value);
            }}
          >
            {ship_table_list?.length > 0 && (
              <>
                {ship_table_list.map((ship) => (
                  <>
                    {!ship.soft_delete && (
                      <>
                        <Select.Option key={ship.id} value={ship.id}>
                          {ship.vessel_name}
                        </Select.Option>
                      </>
                    )}
                  </>
                ))}
              </>
            )}
          </Select>
        </div>
      </div>
      <div className="row" style={{ padding: "10px" }}>
        <div className="col-6" style={{ marginLeft: "5px", alignSelf: "end" }}>
          <div className="theme-content-title text-left">
            <h3>Fuel Change over record Information</h3>
          </div>
        </div>
        <div className="col-3"></div>
        <div className="col-6" style={{ display: "flex", justifyContent: "flex-end" }}>
          <div className="d-flex align-items-center">
            <Button
              type="primary"
              className="save_btn"
              onClick={() => navigate("/audit-trail-fuel-changeover")}
            >
              Audit Trail
            </Button>
          </div>
        </div>
      </div>
      <Table
        bordered
        columns={columns}
        dataSource={filteredData}
        pagination={{ pageSize: 10 }}
        rowKey="key"
        loading={page_loader}
        className="custom-table"
      />
    </>
  );
};

export default ListFuelChangeoverCom;
